import { inject } from '@angular/core';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { ProjectStore } from '@ffx/app-store';

export function uniqueEnvironmentNameValidator(): ValidatorFn {
    const projectStore = inject(ProjectStore);
    const allEnvironments = projectStore.environmentsInGroup;
    return (control: AbstractControl): ValidationErrors | null => {
        const nameExists = allEnvironments().some(
            (environment) => environment.name === control.value && !environment.editing
        );
        return nameExists ? { duplicateEnvironmentName: control.value } : null;
    };
}
